import type { DeviceAgentBuild } from './deviceAgentBuild';

/** Download of the 1QA Load Agent, built into the web image (apps/load-agent -> /downloads). */
export const LOAD_AGENT_DOWNLOAD = '/downloads/1qa-load-agent.zip';
const LOAD_AGENT_BUILD_INFO = '/downloads/1qa-load-agent.json';

/** release/1qa-load-agent.json (apps/load-agent/build.mjs): same shape as the Device Agent's. */
export type LoadAgentBuild = DeviceAgentBuild;

/** The latest build offered for download, or null when unknown (e.g. the Vite dev server has no /downloads). */
export async function fetchLatestLoadAgent(): Promise<LoadAgentBuild | null> {
  try {
    const res = await fetch(LOAD_AGENT_BUILD_INFO, { cache: 'no-cache' });
    if (!res.ok || !res.headers.get('content-type')?.includes('json')) return null;
    const data = (await res.json()) as Partial<LoadAgentBuild>;
    return typeof data.version === 'string' && typeof data.versionName === 'string' ? (data as LoadAgentBuild) : null;
  } catch {
    return null;
  }
}

export const loadAgentFileName = (build: LoadAgentBuild | null) => (build ? `1qa-load-agent-${build.version}.zip` : '1qa-load-agent.zip');
